import {handleResponse} from "@/services/service-helpers.ts";
import log from '@/lib/logger';

const NBH_URL_ROOT = import.meta.env.VITE_NBH_URL_ROOT;

export interface EmailSendLogEntry {
    id: string;
    orderId: string | null;
    recipientEmail: string;
    subject: string;
    emailType: string;
    provider: string;
    status: string;
    failureSummary: string | null;
    attachmentCount: number;
    createdAt: string;
    createdBy: string;
    createdByName: string | null;
}

export interface EmailSendLogPageResponse {
    entries: EmailSendLogEntry[];
    page: number;
    pageSize: number;
    totalElements: number;
    totalPages: number;
}

export async function getOrderEmailLogs(
    token: string | null,
    orderId: string,
): Promise<EmailSendLogEntry[] | void> {
    if (!token) {
        log.error("Can not get order email logs without a valid token.");
        return Promise.reject("No token provided");
    }

    const response = await fetch(`${NBH_URL_ROOT}/api/orders/${orderId}/email-logs`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });

    return handleResponse<EmailSendLogEntry[]>(response);
}

export async function getEmailSendLogs(
    token: string | null,
    page: number = 0,
    size: number = 20,
): Promise<EmailSendLogPageResponse | void> {
    if (!token) {
        log.error("Can not get email send logs without a valid token.");
        return Promise.reject("No token provided");
    }

    const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
    });

    const response = await fetch(`${NBH_URL_ROOT}/api/admin/email-send-logs?${params}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    });

    return handleResponse<EmailSendLogPageResponse>(response);
}
